import { gql } from "@apollo/client";

export const LIST_PAYMENTS = gql`
  query listPayments($filter: PaymentFilter!, $offset: Int, $limit: Int, $orderBy: [String!]) {
    listPayments(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        amount
        date
        validatedAt
        reference
        note
        paymentMethod {
          id
          code
          name
        }
        group {
          client {
            id
            code
            name
            email
          }
          id
          saleDocuments {
            paymentMethod {
              id
              name
              code
            }
            reference
            id
          }
          currency {
            id
            decimalPlaces
            code
          }
        }
        exported
        isReadyToExport
      }
    }
  }
`;
export const LIST_RETURN_PAYMENTS = gql`
  query listReturnPayments(
    $filter: ReturnPaymentFilter
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listReturnPayments(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        amount
        date
        validatedAt
        reference
        note
        paymentMethod {
          id
          code
          name
        }
        group {
          client {
            id
            code
            name
            email
          }
          id
          saleDocuments {
            paymentMethod {
              id
              name
              code
            }
            reference
            id
          }
          currency {
            id
            decimalPlaces
            code
          }
        }
        exported
        isReadyToExport
      }
    }
  }
`;

export const LIST_DIRECT_DEBITS = gql`
  query listDirectDebits(
    $filter: DirectDebitFilter
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listDirectDebits(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        amount
        date
        validatedAt
        groups {
          client {
            id
            code
            name
          }
          id
          currency {
            id
            decimalPlaces
            code
          }
        }
        xmlUrl
        reference
        amountValidated
        status {
          label
          value
        }
        numberOfPayments
      }
    }
  }
`;

export const LIST_SALE_DOCUMENTS_GROUPS = gql`
  query listSalesGroupsGroups(
    $filter: SaleDocumentGroupFilter!
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listSaleDocumentsGroups(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        saleDocuments {
          type {
            label
            value
          }
          reference
          id
          totalPrice
          client {
            id
            name
            code
          }
        }
      }
    }
  }
`;
export const LIST_SALE_DOCUMENTS_GROUPS_FOR_ASYNC_SELECT = gql`
  query listSaleDocumentsGroups(
    $companyId_In: [ID!]
    $saleDocuments_Status_In: [ID!]
    $saleDocumentType: SaleDocumentTypeChoices
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listSaleDocumentsGroups(
      filter: {
        companyId_In: $companyId_In
        saleDocumentType: $saleDocumentType
        saleDocuments_Status_In: $saleDocuments_Status_In
      }
    ) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        saleDocuments {
          type {
            label
            value
          }
          debt
          reference
          id
          totalPrice
          client {
            id
            name
            code
          }
          group {
            id
            currency {
              id
              decimalPlaces
              code
            }
          }
        }
      }
    }
  }
`;

export const LIST_INVOICES_OF_DIRECTS_DEBITS = gql`
  query listSaleDocumentsOfDirectDebits($id: ID!, $offset: Int, $limit: Int, $orderBy: [String!]) {
    listSaleDocumentsOfDirectDebits(id: $id) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        reference
        date
        status {
          label
          value
        }
        client {
          id
          code
          name
        }
        debt
      }
    }
  }
`;

export const LIST_INVOICES_OF_DIRECTS_DEBITS_IDS = gql`
  query listSaleDocumentsOfDirectDebits($id: ID!, $offset: Int, $limit: Int, $orderBy: [String!]) {
    listSaleDocumentsOfDirectDebits(id: $id) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
      }
    }
  }
`;

export const GET_PAYMENT = gql`
  query getPayment($id: ID!) {
    getPayment(id: $id) {
      id
      validatedAt
      reference
      note
      date
      amount
      paymentMethodId
      sepa {
        id
      }
      returnDocument {
        id
        reference
        date
        debt
      }
      group {
        id
        saleDocuments {
          paymentMethod {
            id
            code
            name
          }
          client {
            id
            code
            name
          }
          totalPrice
          reference
          sepa {
            id
          }
          type {
            label
            value
          }
        }
        currency {
          id
          code
          decimalPlaces
        }
      }
    }
  }
`;

export const UPDATE_PAYMENT = gql`
  mutation updatePayment($input: PaymentUpdateInput!) {
    updatePayment(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const UPDATE_DIRECT_DEBIT = gql`
  mutation updateDirectDebit($input: DirectDebitUpdateInput!) {
    updateDirectDebit(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const CREATE_PAYMENT = gql`
  mutation createPayment($input: PaymentCreateInput!) {
    createPayment(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const CREATE_DIRECT_DEBIT = gql`
  mutation createDirectDebit($input: DirectDebitCreateInput!) {
    createDirectDebit(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const DELETE_PAYMENT = gql`
  mutation deletePayment($id: ID!) {
    deletePayment(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const VALIDATE_DIRECT_DEBIT = gql`
  mutation validateDirectDebit($id: ID!, $documentsIds: [ID!]!) {
    validateDirectDebit(id: $id, documentsIds: $documentsIds) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const CANCEL_DIRECT_DEBIT = gql`
  mutation cancelDirectDebit($id: ID!, $documentsIds: [ID!]!) {
    cancelDirectDebit(id: $id, documentsIds: $documentsIds) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const DELETE_DIRECT_DEBIT = gql`
  mutation deleteDirectDebit($id: ID!) {
    deleteDirectDebit(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const LIST_INVOICES_FOR_DIRECT_DEBITS = gql`
  query listDirectDebitSaleDocuments(
    $filter: DirectDebitSaleDocumentFilter!
    $offset: Int
    $limit: Int
  ) {
    listDirectDebitSaleDocuments(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: "-date") {
        id
        paymentDeadlineDate
        date
        validUntil
        errors
        debt
        balance
        totalPrice
        name
        client {
          id
          code
          name
        }
        reference
        type {
          label
          value
        }
        group {
          id
        }
        sepa {
          id
          reference
          paymentPeriod {
            label
            value
          }
        }
      }
    }
  }
`;

export const LIST_INVOICES_FOR_DIRECT_DEBITS_IDS = gql`
  query listDirectDebitSaleDocuments(
    $filter: DirectDebitSaleDocumentFilter!
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listDirectDebitSaleDocuments(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        group {
          id
        }
      }
    }
  }
`;

export const LIST_DEFAULT_FILES_TO_IMPORT = gql`
  query listDefaultFilesToImport(
    $filter: DefaultFileToImportFilter
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listDefaultFilesToImport(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        file
        slug
        name
      }
    }
  }
`;

export const GET_PAYMENTS_XLSX = gql`
  query getPaymentsXlsx($filter: PaymentFilter) {
    getPaymentsXlsx(filter: $filter)
  }
`;
